import React, { ReactNode } from 'react';

import LayoutActivityProvider from '@tb-core/components/context/layout-activity';
import StoreProvider from '@tb-core/components/context/store';
import UserProvider from '@tb-core/components/context/user';
import usePageContext from '@tb-core/hooks/use-page-context';

export interface WebpageLayoutProps {
    regions: {
        bottomBody?: ReactNode;
        footer?: ReactNode;
        head?: ReactNode;
        header?: ReactNode;
        leftAside?: ReactNode;
        main?: ReactNode;
        rightAside?: ReactNode;
        topBody?: ReactNode;
    };
}

const WebpageLayout = ({
    regions: {
        bottomBody,
        footer,
        head,
        header,
        leftAside,
        main,
        rightAside,
        topBody
    }
}: WebpageLayoutProps) => {
    const {
        content: { pageData },
        storeData
    } = usePageContext();
    const { pageControls } = pageData.layout;

    return (
        <LayoutActivityProvider>
            <UserProvider enabled={pageControls?.indexOf('User') >= 0}>
                <StoreProvider initialStore={storeData}>
                    <>
                        {head}
                        {topBody}
                        {header}
                        {leftAside}
                        {rightAside}
                        {main}
                        {footer}
                        {bottomBody}
                    </>
                </StoreProvider>
            </UserProvider>
        </LayoutActivityProvider>
    );
};

export default WebpageLayout;
